<template>
  <div class="specialization-list">
    <label style="font-weight: bold;" class="control-label mb-10 text-left">{{$t('app.inspections.approve.approves')}}</label>
    <div class="panel panel-default border-panel card-view">
      <div class="panel-wrapper collapse in">
        <div class="panel-body">
          <div class="table-wrap">
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr style="width: 100%">
                    <th style="width: 33%">
                      <span>{{$t(`app.inspections.approve.specialization`)}}</span>
                    </th>
                    <th style="width: 33%">
                      <span>{{$t(`app.inspections.approve.status.header`)}}</span>
                    </th>
                    <th style="width: 33%">
                      <span>{{$t(`app.inspections.approve.approve_user`)}}</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(spec,index) in specializations" :key="index">
                    <td style="width: 33%">{{ $t(`app.specializations.${spec.specialization.name}`) }}</td>
                    <td style="width: 33%">{{ approveStatus(spec) }}</td>
                    <td style="width: 33%">{{ userName(spec) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApprovedSpecializations',
  components: {
  },
  props: {
    specializations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {},
  computed: {
  },
  methods: {
    approveStatus(spec) {
      // eslint-disable-next-line max-len
      return (spec.user === undefined || spec.user === null) ? this.$t('app.inspections.approve.status.pending') : this.$t('app.inspections.approve.status.approved');
    },
    userName(spec) {
      return (spec.user === undefined || spec.user === null) ? ' - ' : spec.user.name;
    },
  },
  watch: {},
};
</script>

<style lang="scss">
.specialization-list {
  .control-label {
    margin-left: -9px;
    margin-right: -9px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inspections/ApprovedSpecializations.vue